import cx from "classnames";
import { useRef } from "react";
import { IonLabel, IonModal } from "@ionic/react";

import s from "./SurveySubmitConfirmationModal.module.scss";
import { WLButton } from "../../../../Common/components/WLButton/WLButton";

interface SurveySubmitConfirmationModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  onGoBack: () => void;
  onSubmit: () => void;
}

export const SurveySubmitConfirmationModal = ({
  isOpen,
  onDismiss,
  onGoBack,
  onSubmit,
}: SurveySubmitConfirmationModalProps) => {
  const modal = useRef<HTMLIonModalElement>(null);

  const handleDismiss = () => {
    modal.current?.dismiss();
    onDismiss();
  };

  const handleGoBack = () => {
    handleDismiss();
    onGoBack();
  };

  const handleSubmit = () => {
    handleDismiss();
    onSubmit();
  };

  return (
    <IonModal
      id="survey-submit-confirmation-modal"
      className={s.modal}
      backdropDismiss={true}
      ref={modal}
      isOpen={isOpen}
      onDidDismiss={handleDismiss}
    >
      <div className={s.container}>
        <div className={s.modalContentWrapper}>
          <div className={s.modalContent}>
            <div className={s.modalContentTitle}>
              <IonLabel className="win-header-1 winner-sans medium white ion-text-uppercase">
                Ready to Submit?
              </IonLabel>
              <IonLabel className="win-header-5 gilroy medium blue-grey200_2">
                You're about to submit your survey. Make sure everything looks
                good—you can still edit if needed.
              </IonLabel>
            </div>

            <div className={s.buttonsContainer}>
              <WLButton
                onClick={handleGoBack}
                className={cx(
                  s.button,
                  s.goBackButton,
                  "wl-body-6 bold ion-margin-top"
                )}
              >
                Go Back and Review
              </WLButton>
              <WLButton
                onClick={handleSubmit}
                className={cx(
                  s.button,
                  s.submitButton,
                  "red-submit-button wl-body-6 bold ion-margin-top"
                )}
              >
                Submit Now
              </WLButton>
            </div>
          </div>
        </div>
      </div>
    </IonModal>
  );
};
